// src/App.tsx
import { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


import { Flip } from "gsap/Flip";
import LoadingScreen from "./components/loadingScreen";
import NavBar from "./components/navBar";
import MobileHero from "./components/mobile/hero";

import WelcomeText from "./components/mobile/welcomeText";

import TeamPhotosMobile from "./components/mobile/TeamPhotosMobile";

import TheTeam from "./components/mobile/theTeam";

import Partners from "./components/mobile/Partners";

import ContactUs from "./components/contactUs";

import Fan from "./components/mobile/socials";

import Footer from "./components/footer";

import ColorBends from './components/ColorBends';

import "./styles/globals.css";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);

export default function MobileLayout() {
    const [loading, setLoading] = useState(true);
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            const logo = document.querySelector(".app-logo");

            const state = Flip.getState(logo);
            setLoading(false); // triggers flip animation later

            setTimeout(() => {
                const tl = gsap.timeline();

                tl.add(
                    Flip.from(state, {
                        duration: 2,
                        ease: "power3.inOut",
                        scale: true,
                        absolute: true,
                    })
                );

                // ➜ After the animation, THEN hide loader
                tl.call(() => setShowLoader(false));

            }, 150);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);







    return (
        <div className="min-h-[calc(var(--vh)*100)] bg-background text-foreground">
            <div className="fixed inset-0 -z-10 pointer-events-none bg-[#000000]">
                <ColorBends
                    colors={["#712177", "#A574BF", "#201647"]}
                    rotation={45}
                    speed={0.3}
                    scale={1}
                    frequency={1}
                    warpStrength={1}
                    mouseInfluence={0.8}
                    parallax={0.6}
                    noise={0.08}
                    transparent
                />

            </div>

            {showLoader && <LoadingScreen done={!loading} />}
            {!loading && <NavBar />}

            <main className="main-content min-h-full min-w-full relative flex flex-col">
                {!loading && (
                    <>

                        <MobileHero/>

                        <WelcomeText />

                        <TeamPhotosMobile />



                        <TheTeam />

                        <Partners />

                        <ContactUs />

                        <Fan />

                        <Footer />
                    </>
                )}
            </main>
        </div>
    );
}
